import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@/store/Reducer'

const selectHopTimus = (state: RootState) => state.hopTimus

export const selectHopTimusIsLoading = createSelector(selectHopTimus, hopTimus => hopTimus.isLoading)
